import MenuItems from '../MenuItems/menu-items';

export default MenuItems;